import { styled } from "@mui/material";

export const NavSpacerWrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "$navItemsHeight",
})<{ $navItemsHeight?: number }>`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.default};
  min-height: ${({ $navItemsHeight }) => $navItemsHeight}px;
`;
